import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FaceDizzy"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM10.8074 8.25L9.74988 7.1925L8.24988 8.6925L6.74988 7.1925L5.69238 8.25L7.19238 9.75L5.69238 11.25L6.74988 12.3075L8.24988 10.8075L9.74988 12.3075L10.8074 11.25L9.30738 9.75L10.8074 8.25ZM18.3074 8.25L17.2499 7.1925L15.7499 8.6925L14.2499 7.1925L13.1924 8.25L14.6924 9.75L13.1924 11.25L14.2499 12.3075L15.7499 10.8075L17.2499 12.3075L18.3074 11.25L16.8074 9.75L18.3074 8.25ZM9.74984 16.5C9.74984 15.2574 10.7572 14.25 11.9998 14.25C13.2425 14.25 14.2498 15.2574 14.2498 16.5C14.2498 17.7427 13.2425 18.75 11.9998 18.75C10.7572 18.75 9.74984 17.7427 9.74984 16.5ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FaceDizzy.vue"]]);
